import { QuestionBase } from './question-base.model';

export class EditableGrid extends QuestionBase<string> {
    controlType = 'editgrid';
    resource: any;
    data: any;
    visible: string;
    confg:any
    constructor(options: {} = {}) {
        super(options);
        this.resource = options['resource'];
        this.data = options['data'];
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
        this.value = options['data'];
        this. confg={
            item:options['data']
        }
    }
}
